/**
 * Каталог симуляций «Лаборатории»: раздел → тема → симуляция → экраны (план, редакция 2).
 * Новая симуляция — файл описания рядом и строка здесь.
 */
import { ИНЕРЦИЯ } from './inerciya.ts'
import type { Симуляция } from './opisanie.ts'
import { ВЗАИМОДЕЙСТВИЕ } from './vzaimodeystvie.ts'

export const СИМУЛЯЦИИ: readonly Симуляция[] = [ИНЕРЦИЯ, ВЗАИМОДЕЙСТВИЕ]

export function найтиСимуляцию(id: string | undefined): Симуляция | undefined {
  return СИМУЛЯЦИИ.find((с) => с.id === id)
}
